import { render, staticRenderFns } from "./KlarnaSizeableIcon.vue?vue&type=template&id=9c273302&"
import script from "./KlarnaSizeableIcon.vue?vue&type=script&lang=js&"
export * from "./KlarnaSizeableIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports